export const isContains = (keyword, string, isEmptyString = false) => {
  if (isEmptyString && !keyword.length) {
    return true
  }
  return keyword.length && string.toLowerCase().indexOf(keyword.toLowerCase()) > -1
}


// WEBPACK FOOTER //
// ./src/components/utils/isContains.js